module.exports = __webpack_public_path__ + "img/number_02.dc6591c6.svg";